import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { updatePharmacyListTitle } from '../../actions/metaActions';
import { getFpactList } from '../../actions/locationActions';

@connect((store) => {
    return { title: store.meta.pharmacyListingTitle };
})
class FpactList extends React.Component {
    constructor(props) {
        super(props);
        this.goToPharmacyList = this.goToPharmacyList.bind(this);
    }

    goToPharmacyList() {
        this.props.dispatch(updatePharmacyListTitle('FPACT Pharmacies'));
        this.props.history.push('/pharmacylist');
    }

    render() {
        return (
            <div>
                <h1 className="ec__font__title text-center">FPACT Pharmacies</h1>
                
                <div className="row justify-content-md-center">
                    <div className="col-md-6">
                        <p className="ec__font__body">
                            Call first and ask:
                        </p>
                        <br/>
                        <p className="ec__font__body ec__font__body--blue no-bottom-margin">
                            “Hi! Is there a pharmacist on duty who can give me emergency contraception that’s covered by FPACT?”
                        </p>
                        <br/>
                        <p className="ec__font__body">
                            Bring the green card with you. 
                        </p>
                    </div>
                </div>
                

                <div className="row">
                    <div className="choices col text-center">
                        <button className="ec__button" onClick={this.goToPharmacyList}>See pharmacy list</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default FpactList;


// WEBPACK FOOTER //
// ./src/components/screens/FpactList.js